module.exports = __webpack_public_path__ + "img/livechasing-app-icon.c29d9e01.png";